import { createVanIconComponent } from "./van"

const ClockOutlined = createVanIconComponent("clock-o")
export default ClockOutlined
